import { MessageCircle, Star, TrendingUp, ArrowRight } from "lucide-react";
import { LINE_URL } from "../constants";

const FooterCTA = () => {
  return (
    <section data-testid="footer-cta" className="py-14 md:py-32 bg-[#0A2540] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF6B00]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0047FF]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto px-5 md:px-12 text-center relative z-10">
        <h2 className="text-[1.75rem] leading-tight sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-5 md:mb-6">
          準備好讓您的民宿
          <span className="text-[#FF6B00] block mt-2">營收翻倍成長了嗎？</span>
        </h2>
        <p className="text-base md:text-lg text-white/80 mb-8 md:mb-10 max-w-2xl mx-auto px-2 leading-relaxed">
          為了維持品質，我們每月合作名額僅限 3 間。立即預約免費諮詢，讓專業顧問為您量身打造獲利策略。
        </p>
        
        <a href={LINE_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-cta-btn"
          className="inline-flex items-center gap-2 md:gap-3 bg-[#FF6B00] text-white hover:bg-[#E65A00] transition-all duration-300 font-bold rounded-full px-7 md:px-10 py-4 md:py-5 text-base md:text-lg btn-lift animate-pulse-glow">
          <MessageCircle className="w-5 h-5 md:w-6 md:h-6" />
          立即 LINE 諮詢
          <ArrowRight className="w-5 h-5" />
        </a>

        <div className="mt-10 md:mt-12 flex flex-wrap justify-center gap-4 md:gap-8 text-white/60 text-sm md:text-base">
          <div className="flex items-center gap-2">
            <Star className="w-4 h-4 md:w-5 md:h-5" />
            <span>500+ 網紅合作</span>
          </div>
          <div className="flex items-center gap-2">
            <TrendingUp className="w-4 h-4 md:w-5 md:h-5" />
            <span>260% 營收成長</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterCTA;
